<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Vytvorenie farmy -->
                    <div v-if="profil.pouzivatel_id"  class="col-xs-12 col-md-12 col-lg-8 col-xl-7">
                        <div class="header d-flex align-items-center justify-content-between">
                            <h2>Vytvorte si mliečnu farmu</h2>
                        </div>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>

                        <!-- Form Box -->
                        <form @submit="formSubmit"><br>
                            <!-- Meno + Názov -->
                            <div class="row mb-5">
                                <div class="col-sm-6 mb-2 mb-md-0">
                                    <label class="form-label">Meno farmára</label>
                                    <input type="text" class="form-control" v-model="meno_farmara">
                                </div>

                                <div class="col-sm-6">
                                    <label class="form-label">Názov mliečnej farmy</label>
                                    <input type="text" class="form-control" v-model="nazov_farmy">
                                </div>
                            </div>

                            <div class="row mb-5">
                                <label>
                                    <h3 class="modal-title mb-2">Vyberte si postavu</h3>
                                </label>
                                <!-- *Preloader box -->
                                <div v-if="farmar_skin_id == ''" class="col-sm-3 text-center">
                                    <div class="cow-wrapper dojicka mb-3 md-md-0">
                                        <label class="check-container">
                                            <img src="" width="60px" height="130px" style="visibility:hidden">
                                        </label>
                                    </div>
                                </div>
                                <!-- *Content -->
                                <div v-else v-for="skin in farmar_skiny" class="col-sm-3 text-center">
                                    <div class="cow-wrapper dojicka mb-3 md-md-0">
                                        <label class="check-container">
                                            <img :src="'https://www.adoptujkravicku.sk/hra/dist/images/' + skin.farmar_styl_img" width="60px" height="130px">
                                            <input type="radio" v-model="farmar_skin_id" :value="skin.id">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <h3>Vyberte si kravičku</h3>
                            <div class="row mb-5">
                                <!-- *Preloader box -->
                                <div v-if="profil.pouzivatel_id && profil.pouzivatel_id.kravicky_pouzivatela.length == 0" class="col-sm-3 text-center">
                                    <div class="cow-wrapper mastal mb-3 md-md-0">
                                        <label class="check-container">
                                            <img src="" width="140px" height="130px" style="visibility:hidden">
                                        </label>
                                        <h2 class="cow-name gamma">&nbsp;</h2>
                                    </div>
                                </div>
                                <!-- *Content -->
                                <div v-for="kravicka in profil.pouzivatel_id.kravicky_pouzivatela" class="col-sm-3 text-center">
                                    <div class="cow-wrapper mastal mb-3 md-md-0">
                                        <label class="check-container">
                                            <img :src="'https://www.adoptujkravicku.sk/data/foto/' +  kravicka.kravicka_img_hlava" class="img-responsive" width="140px" height="130px">
                                            <input type="radio" v-model="kravicka_id" :value="kravicka.id">
                                            <div></div>
                                            <span class="checkmark"></span>
                                        </label>
                                        <h2 class="cow-name gamma">{{ kravicka.kravicka_meno }}</h2>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-5">
                                <GmapMap
                                    ref="mapaVytvorenieFarmy"
                                    :center="{lat: 48.707786, lng: 19.467559}"
                                    :zoom="8"
                                    :options='{
                                        draggableCursor: "pointer",
                                        draggingCursor: "pointer",
                                        panControl: false,
                                        disableDefaultUI: true,
                                        mapTypeControl: false,
                                        draggable: true,
                                        zoomControl: true,
                                        styles: [{
                                            "elementType": "geometry",
                                            "stylers": [{"hue": "#ff4400"}, {"saturation": -68}, {"lightness": -4}, {"gamma": 0.72}]
                                            }, {"featureType": "road", "elementType": "labels.icon"}, {
                                            "featureType": "landscape.man_made",
                                            "elementType": "geometry",
                                            "stylers": [{"hue": "#0077ff"}, {"gamma": 3.1}]
                                            }, {
                                            "featureType": "water",
                                            "stylers": [{"hue": "#00ccff"}, {"gamma": 0.44}, {"saturation": -33}]
                                            }, {
                                            "featureType": "poi.park",
                                            "stylers": [{"hue": "#44ff00"}, {"saturation": -23}]
                                            }, {
                                            "featureType": "water",
                                            "elementType": "labels.text.fill",
                                            "stylers": [{"hue": "#007fff"}, {"gamma": 0.77}, {"saturation": 65}, {"lightness": 99}]
                                            }, {
                                            "featureType": "water",
                                            "elementType": "labels.text.stroke",
                                            "stylers": [{"gamma": 0.11}, {"weight": 5.6}, {"saturation": 99}, {"hue": "#0091ff"}, {"lightness": -86}]
                                            }, {
                                            "featureType": "transit.line",
                                            "elementType": "geometry",
                                            "stylers": [{"lightness": -48}, {"hue": "#ff5e00"}, {"gamma": 1.2}, {"saturation": -23}]
                                            }, {
                                            "featureType": "transit",
                                            "elementType": "labels.text.stroke",
                                            "stylers": [{"saturation": -64}, {"hue": "#ff9100"}, {"lightness": 16}, {"gamma": 0.47}, {"weight": 2.7}]
                                            }]
                                    }'
                                    style="width: 100%; height: 270px;"
                                    @click="positionClick"
                                >
                                </GmapMap>
                                <input type="hidden" v-model="lat">
                                <input type="hidden" v-model="lng">
                            </div>



                            <!-- Submit -->
                            <div v-if="profil.pouzivatel_id && profil.id != 0 && profil.pouzivatel_id.farma_pouzivatela.length == 0 && !isDisabled" class="row">
                                <div class="col-md-12">
                                    <button class="btn --primary">VYTVORIŤ MLIEČNU FARMU</button>
                                </div>
                            </div>

                        </form>
                        <!-- .Form Box -->

                    </div>
                    <!-- .Heslo -->

                </div>
            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    import {gmapApi} from 'vue2-google-maps'
    import {slovakia} from '@/services/hranice.js'

    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
            this.getFarmarStyl()
        },
        updated() {
            if (this.updated == 0) {
                this.getFarmarStyl()
            }
        },
        computed: {
            google: gmapApi
        },
        data() {
            return {
                meno_farmara: '',
                nazov_farmy: '',
                farmar_skin_id: '',
                kravicka_id: '',
                farmar_skiny: [],
                lat: '',
                lng: '',

                updated: 0,
                isDisabled: 0,

                responseType: '',
                responseText: '',

                markers: []
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // mounted
            getFarmarStyl() {
                if (typeof(this.profil.pouzivatel_id) != 'undefined' && this.profil.id != 0) {
                    this.updated = 1

                    EventService.getFarmarStyl()
                        .then(response => {
                            //console.log(response.data)
                            this.kravicka_id    = this.profil.pouzivatel_id.kravicky_pouzivatela[0].id
                            this.farmar_skiny   = response.data.data
                            this.farmar_skin_id = this.farmar_skiny[0].id
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })
                }
            },


            // submit
            formSubmit(e) {
                this.isDisabled = 1
                e.preventDefault()
                this.createFarm()
            },

            createFarm() {
                EventService.createFarm(this.profil.pouzivatel_id.id, this.meno_farmara, this.nazov_farmy, this.farmar_skin_id, this.kravicka_id, this.lat, this.lng)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        if (response.data.code == 'success') {
                            var update = [{
                                herna_farma_kapacita_kraviciek: 1, 
                                id: parseInt(response.data.id)
                            }]
                            this.profil.pouzivatel_id.farma_pouzivatela = update
                            this.$emit('update:profil', this.profil)

                        } else {
                            this.isDisabled = 0
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },

            positionClick(coordinates) {
                let slovakBorders = new google.maps.Polygon({paths: slovakia})

                if ( this.google.maps.geometry.poly.containsLocation(coordinates.latLng, slovakBorders) ) {
                    this.lat = coordinates.latLng.lat()
                    this.lng = coordinates.latLng.lng()
                    this.$refs.mapaVytvorenieFarmy.$mapPromise.then((mapaVytvorenieFarmy) => {

                        let marker = new google.maps.Marker({
                            position: coordinates.latLng,
                            icon: 'https://www.adoptujkravicku.sk/engine/wp-content/themes/Zephyr-child/images/dvor-pin.png'
                        })

                        this.markers.forEach(function (markersItem) {
                            markersItem.setMap(null)
                        })

                        marker.setMap(mapaVytvorenieFarmy)
                        this.markers.push(marker)

                    })
                }
                else {
                    alert('Farma musí byť v rámci hraníc Slovenska')
                }
            }
        }
    }
</script>